<div class="astral-auth-shell">
  <main class="astral-auth-panel astral-auth-panel--wide hogia-id-association">
    <header class="astral-auth-header">
      <div class="astral-auth-branding">
        <img src="assets/icons/hogia_logo.svg" alt="Hogia" />
        <span class="astral-auth-branding__divider" aria-hidden="true"></span>
        <span class="astral-auth-branding__name">DinHyresvärd</span>
        @if (envName) {
          <span class="astral-auth-branding__environment">{{ envName }}</span>
        }
      </div>
      <app-language class="astral-auth-language" [orientation]="2"></app-language>
    </header>

    <section class="astral-auth-content">
      @if (phase === 'authenticate') {
        <div class="hogia-id-association__stack">
          <h1 class="astral-auth-title">{{ 'HOGIA_ID_ASSOCIATION.AUTH_TITLE' | translate }}</h1>
          <p>{{ 'HOGIA_ID_ASSOCIATION.AUTH_MESSAGE' | translate }}</p>

          <astral-tabs
            appearance="tinted"
            [tabs]="authMethods"
            [selectedId]="authMethod"
            (selectedIdChange)="selectAuthMethod($event)"
            ariaLabel="HOGIA_ID_ASSOCIATION.AUTH_TITLE"
            panelId="association-auth-method-panel"
            tabIdPrefix="association-auth-method"
            [disabled]="requestPending"
          ></astral-tabs>

          <div
            id="association-auth-method-panel"
            role="tabpanel"
            [attr.aria-labelledby]="'association-auth-method-' + authMethod"
          >
            @if (authMethod === 'password') {
              <form class="hogia-id-association__stack" [formGroup]="authenticationForm" (ngSubmit)="authenticateWithPassword()">
                <astral-input
                  [control]="usernameControl"
                  type="text"
                  inputId="association-username"
                  inputName="username"
                  inputMode="email"
                  autocomplete="username"
                  [enableContactAction]="false"
                  [showRequiredMarker]="false"
                ></astral-input>
                <astral-input
                  [control]="passwordControl"
                  type="password"
                  inputId="association-password"
                  inputName="password"
                  autocomplete="current-password"
                  [showRequiredMarker]="false"
                ></astral-input>
                @if (authenticationRejected) {
                  <p class="hogia-id-association__error" role="alert">
                    {{ 'HOGIA_ID_ASSOCIATION.AUTH_REJECTED' | translate }}
                  </p>
                }
                <astral-button
                  class="astral-auth-action--wide"
                  type="submit"
                  variant="primary"
                  [disabled]="requestPending"
                  labelKey="HOGIA_ID_ASSOCIATION.CONTINUE"
                ></astral-button>
              </form>
            } @else {
              <div class="hogia-id-association__stack" #bankIdContainer>
                @if (bankIdRunning) {
                  <app-bankid-auth
                    [isAutoStart]="bankIdAutoStart"
                    (result)="bankIdCompleted($event)"
                    (requestFullscreen)="onRequestFullscreen()"
                  ></app-bankid-auth>
                } @else {
                  @if (authenticationRejected) {
                    <p class="hogia-id-association__error" role="alert">
                      {{ 'HOGIA_ID_ASSOCIATION.AUTH_REJECTED' | translate }}
                    </p>
                  }
                  <div class="hogia-id-association__bankid-actions" [class.mobile-device-prompt]="isMobile">
                    <astral-button
                      class="astral-auth-action--wide"
                      type="button"
                      [variant]="isMobile ? 'secondary' : 'primary'"
                      [disabled]="requestPending"
                      labelKey="LOGIN_FORM.START_BANKID_OTHER_DEVICE"
                      (click)="startBankId(false)"
                    ></astral-button>
                    <astral-button
                      class="astral-auth-action--wide"
                      type="button"
                      [variant]="isMobile ? 'primary' : 'secondary'"
                      [disabled]="requestPending"
                      labelKey="LOGIN_FORM.START_BANKID"
                      (click)="startBankId(true)"
                    ></astral-button>
                  </div>
                }
              </div>
            }
          </div>

          <astral-button
            type="button"
            variant="secondary"
            [disabled]="requestPending"
            labelKey="CANCEL_BTN"
            (click)="cancel()"
          ></astral-button>
          @if (requestPending) {
            <p class="hogia-id-association__status" role="status">{{ 'HOGIA_ID_ASSOCIATION.WORKING' | translate }}</p>
          }
        </div>
      } @else if (phase === 'confirm') {
        <div class="hogia-id-association__stack" aria-live="polite">
          <h1 class="astral-auth-title">{{ 'HOGIA_ID_ASSOCIATION.CONFIRM_TITLE' | translate }}</h1>
          <p>{{ 'HOGIA_ID_ASSOCIATION.CONFIRM_MESSAGE' | translate }}</p>
          <dl class="hogia-id-association__preview">
            <div>
              <dt>{{ 'HOGIA_ID_ASSOCIATION.DH_ACCOUNT' | translate }}</dt>
              <dd>{{ preview?.dhUserName }}</dd>
            </div>
            <div>
              <dt>{{ 'HOGIA_ID_ASSOCIATION.ORGANIZATION' | translate }}</dt>
              <dd>{{ preview?.organizationName }}</dd>
            </div>
            <div>
              <dt>{{ 'HOGIA_ID_ASSOCIATION.HOGIA_ACCOUNT' | translate }}</dt>
              <dd>
                {{
                  preview?.hogiaDisplayName ||
                    ('HOGIA_ID_ASSOCIATION.HOGIA_ACCOUNT_UNKNOWN' | translate)
                }}
              </dd>
            </div>
          </dl>
          <div class="hogia-id-association__actions">
            <astral-button
              type="button"
              variant="primary"
              [disabled]="requestPending"
              labelKey="HOGIA_ID_ASSOCIATION.CONFIRM"
              (click)="confirm()"
            ></astral-button>
            <astral-button
              type="button"
              variant="secondary"
              [disabled]="requestPending"
              labelKey="LOGOUT_BTN"
              (click)="logout()"
            ></astral-button>
            <astral-button
              type="button"
              variant="secondary"
              [disabled]="requestPending"
              labelKey="HOGIA_ID_ASSOCIATION.CONTINUE_WITHOUT_LINKING"
              (click)="cancel()"
            ></astral-button>
          </div>
          @if (requestPending) {
            <p class="hogia-id-association__status" role="status">{{ 'HOGIA_ID_ASSOCIATION.WORKING' | translate }}</p>
          }
        </div>
      } @else {
        <div class="hogia-id-association__stack" aria-live="polite">
          <h1 class="astral-auth-title">{{ 'HOGIA_ID_ASSOCIATION.FAILURE_TITLE' | translate }}</h1>
          <p>
            {{
              (confirmOutcomeUncertain
                ? (hasAuthenticatedSession
                    ? 'HOGIA_ID_ASSOCIATION.CONFIRM_UNCERTAIN_AUTHENTICATED'
                    : 'HOGIA_ID_ASSOCIATION.CONFIRM_UNCERTAIN')
                : (hasAuthenticatedSession
                    ? 'HOGIA_ID_ASSOCIATION.FAILURE_MESSAGE_AUTHENTICATED'
                    : 'HOGIA_ID_ASSOCIATION.FAILURE_MESSAGE')) | translate
            }}
          </p>
          <div class="hogia-id-association__actions">
            <astral-button
              type="button"
              variant="primary"
              [labelKey]="hasAuthenticatedSession
                ? (confirmOutcomeUncertain
                    ? 'HOGIA_ID_ASSOCIATION.CONTINUE_TO_DH'
                    : 'HOGIA_ID_ASSOCIATION.CONTINUE_WITHOUT_LINKING')
                : 'HOGIA_ID_LOGIN.RETURN_TO_LOGIN'"
              (click)="continueToDh()"
            ></astral-button>
            @if (hasAuthenticatedSession) {
              <astral-button
                type="button"
                variant="secondary"
                labelKey="LOGOUT_BTN"
                (click)="logout()"
              ></astral-button>
            }
          </div>
        </div>
      }
    </section>
  </main>
</div>
